const setCookie = (day, item) => {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = `${item}; expires=${date.toUTCString()}; path=/`;
};

export default setCookie;